module.exports = __webpack_public_path__ + "img/MylesBrownMD.b1e6e2df.png";